import React from "react";
import SectionHead from "./SectionHead";
import { GiCutDiamond } from "react-icons/gi";
import { values } from "../data";
import Card from "../UI/Card";
import Image from "../images/values.jpg";

const Values = () => {
  return (
    <section className="values">
      <div className="container values__container">
        <div className="values__left">
          <div className="values__image">
            <img src={Image} alt="Values" />
          </div>
        </div>
        <div className="right">
          <SectionHead icon={<GiCutDiamond />} title="values"></SectionHead>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ullam odit
            provident iste, expedita quaerat cum aliquid 
          </p>
          <div className="values__wrapper">
            {values.map(({ id, icon,title, desc }) => {
              return(
                <Card className="values__value" key={id}>
                  <span>{icon}</span>
                  <h4>{title}</h4>
                  <small>{desc}</small>
                </Card>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Values;
